import React, { useEffect, Suspense } from 'react'
import { useLocation, useHistory, Route, Redirect, Switch } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { useAuthContext } from '@eqworks/common-login'

import { NavSelectors } from '../../modules/nav'
import MuiNav from './components/topnav/navbar'
import { routePrefix } from '../../helpers/utils/routing'
import { routes } from './route-config'
import { GlobalLoader } from '../../common-components'
import { renderErrorBoundedRoute as renderRoute } from '../../common-components/error-boundary'
import getAccess, {
  checkUserRoles,
  getVisibleRoutes,
} from '../../helpers/utils/auth'
import IframeContainer from '../iframe-container'


const { getSelectorNav } = NavSelectors

const propTypes = {
  displayMainHeader: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
}

const AuthenticatedApp = (props) => {

  const history = useHistory()
  const location = useLocation()

  const { authState: { user }, authActions: { logOut, logOutAll } } = useAuthContext()

  useEffect(() => {
    // identify user email with inspectlet
    if (Object.prototype.hasOwnProperty.call(window, '__insp')) {
      window.__insp.push(['identify', user])
    }
  }, [user])

  const { isLoading } = props
  const access = getAccess()
  const userRoles = checkUserRoles(access)
  const visibleRoutes = getVisibleRoutes({ userRoles, ...access })
  const routesRendered = routes.filter(({ section }) => visibleRoutes.includes(section))

  return (
    <div>
      <MuiNav
        location={location}
        logOut={logOut}
        logOutAll={logOutAll}
        email={user}
        access={access}
        history={history}
      />


      <GlobalLoader isLoading={isLoading} />
      <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          {routesRendered.map(({ route, Component, to, exact }) => {
            if (to) {
              return <Redirect key={route} from={`${routePrefix}/${route}`} to={to} />
            }
            return (
              <Route
                key={route}
                exact={exact}
                path={`${routePrefix}/${route}`}
                render={renderRoute(Component)}
              />
            )
          })}
          <Route key='locus.city' exact path='/city'>
            <IframeContainer title='LOCUS City Demo'>https://locus.city/</IframeContainer>
          </Route>
          <Route render={() => (<Redirect to='/home' />)} />
        </Switch>
      </Suspense>
    </div>
  )
}

AuthenticatedApp.propTypes = propTypes

const mapStateToProps = (state) => ({ ...getSelectorNav(state) })

export default connect(mapStateToProps)(AuthenticatedApp)
